export default __webpack_public_path__ + "static/media/logo-complex-networks-white.3ba4f230.svg";